window.projectsDropdownFilter = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const button = document.querySelector('.jsDropdownButton2');
    const buttonText = document.querySelector('.jsProjectsDropdownButtonText');
    const list = document.querySelector('.jsProjectsDropdownList');
    const listLinks = document.querySelectorAll('.jsProjectsDropdownList a');
    const mobileListBtn = document.querySelector('.jsProductsMobileListButton');
    const mobileList = document.querySelector('.jsProductsMobileList');
    const mobileBtnText = document.querySelector('.jsProjectsDropdownMobileButtonText');

    mobileListBtn.addEventListener('click', () => {
      mobileListBtn.classList.toggle('active');

      if (mobileList.style.display === 'none') {
        mobileList.style.display = 'block';
        return;
      }
      mobileList.style.display = 'none';
    });

    button.addEventListener('click', () => {
      button.classList.toggle('active');
      slideToggle(list, 500);
    });

    const url = new URL(window.location.href);
    const categoryParam = url.searchParams.get("category");

    const widthArray = [];

    const bottomLinks = document.querySelectorAll('.jsProjectsBottomList a');

    const linkWidthArray = [];
    bottomLinks.forEach(el => {
      linkWidthArray.push(el.parentElement.getBoundingClientRect().width);
    })
    const widestProjectCategory = `${Math.max(...linkWidthArray)}px`;
    button.style.width = widestProjectCategory;
    list.style.width = widestProjectCategory;

    listLinks.forEach(el => {
      const textWidth = el.getBoundingClientRect().width;
      widthArray.push(textWidth);
      if (el.getAttribute('data-category-slug') === categoryParam) {
        buttonText.innerText = el.innerText;
        mobileBtnText.innerText = el.innerText;
        el.classList.add('dropdownProject__link--active');
        const bottomLink = document.querySelector(`.jsProjectsBottomList a[data-category-slug="${categoryParam}"]`);

        if (bottomLink) {
          bottomLink.classList.add('dropdownProject__link--active');
        }
      }
    });
  });

};
